"use client";

import React from "react";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function PainPointIdentification() {
  const painPoints = [{
    title: "The 'Gymtimidation' is Real",
    description: "Big box gyms feel like a performance art piece you didn't audition for. You just want to move, not be judged."
  }, {
    title: "Singapore Pace, Zero Space",
    description: "Your schedule is packed, and the last thing you want is a 40-minute commute to a crowded fitness center."
  }, {
    title: "The 'All-or-Nothing' Trap",
    description: "You think fitness means chicken breast and 5am sprints. We're here to tell you it's okay to take life less seriously."
  }];
  return;
}